<form [formGroup]="form">

  <div class="form-row">
    <label for="txtTitle">Título</label>
    <input type="text" id="txtTitle" class="w-full" pInputText formControlName="title" />
  </div>

  <div class="form-row">
    <label for="txtCode">Código</label>
    <input type="text" id="txtCode" class="w-full" pInputText formControlName="key" (input)="transformarValor()" />
  </div>

  <div class="form-row">
    <p-checkbox inputId="isDefault" [binary]="true" formControlName="isDefault"></p-checkbox>
    <label class="checkbox-label" for="isDefault">Perfil por defecto</label>
  </div>

  <div class="form-row">
    <label for="selectedApplication">Aplicación</label>
    <app-application-select formControlName="applicationId"></app-application-select>
  </div>

</form>

<div class="p-dialog-footer">

  <p-button label="Guardar cambios" (click)="saveChanges()" [loading]="saving"></p-button>

</div>
